import React from 'react';
import './Home.css';
import Profile from './Profile/Profile';

// import Footer from './Footer/Footer';

export default function Home() {
  return (
    <div className="home-container" id='Home'>
        <Profile/>
    </div>
  )
}
